import type React from 'react'
import { Box, MenuItem, Select, Typography } from '@mui/material'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { color } from 'config/color'
import { ErrorText, FormLabel } from 'components'

interface MenuItems {
  label: string
  value: string
}


interface DropDownProps {
  fieldName: string
  fieldLabel: string
  fieldType: string
  control: Control<any>
  errors: FieldErrors<any>
  placeholder?: string
  options: string[] | MenuItems[]
}

export const DropDown: React.FC<DropDownProps> = (props: DropDownProps) => {
  return (
    <Box mb={2}>
      <Controller
        name={props.fieldName}
        control={props.control}
        render={({ field }) => (
          <Box>
            <FormLabel>{props.fieldLabel.toUpperCase()}</FormLabel>
            <Select
              fullWidth
              renderValue={(value) =>
                value.length !== 0
                  ? (
                    <Typography>{value}</Typography>
                  )
                  : (
                    <Typography color={color.grey[400]} fontSize="medium">
                      {props.placeholder}
                    </Typography>
                  )
              }
              displayEmpty={true}
              {...field}
            >
              {props.options.map((item, index) => {
                if (typeof item === 'string') {
                  return (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  )
                } else {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                }
              })}
            </Select>
            {(props.errors[props.fieldName] != null) && (
              <ErrorText>{String(props.errors[props.fieldName]?.message)}</ErrorText>
            )}
          </Box>
        )}
      />
    </Box>
  )
}
